import * as ActionTypes from '../ActionTypes';

const initialState = {
    employeeClearanceLoading: false,
    employeeClearanceData: [],
    error: null,
};

export const EmployeeClearanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.EMPLOYEE_CLEARANCE_GET_REQUEST:
            return {
                ...state,
                employeeClearanceLoading: true,
                employeeClearanceData: [],
                error: null,
            };

        case ActionTypes.EMPLOYEE_CLEARANCE_ADD_REQUEST:
        case ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_REQUEST:
        case ActionTypes.EMPLOYEE_CLEARANCE_DELETE_REQUEST:
            return {
                ...state,
                employeeClearanceLoading: true,
                error: null,
            };

        case ActionTypes.EMPLOYEE_CLEARANCE_GET_SUCCESS:
        case ActionTypes.EMPLOYEE_CLEARANCE_ADD_SUCCESS:
        case ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_SUCCESS:
        case ActionTypes.EMPLOYEE_CLEARANCE_DELETE_SUCCESS:
            return {
                ...state,
                employeeClearanceLoading: false,
                employeeClearanceData: action.payload?.data?.data || [],
                error: null,
            };

        case ActionTypes.EMPLOYEE_CLEARANCE_GET_ERROR:
        case ActionTypes.EMPLOYEE_CLEARANCE_ADD_ERROR:
        case ActionTypes.EMPLOYEE_CLEARANCE_UPDATE_ERROR:
        case ActionTypes.EMPLOYEE_CLEARANCE_DELETE_ERROR:
            return {
                ...state,
                employeeClearanceLoading: false,
                error: true,
            };

        default:
            return state;
    }
};
